import { IonIcon } from "@ionic/react";
import { chevronDown } from "ionicons/icons";
import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";

const Container = styled.div`
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	position: relative;
	width: 100%;
`;

const ContentWrapper = styled.div<any>`
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	overflow: hidden;
	transition: all 0.3s ease-in-out;
	max-height: ${(props) => (props.isExpanded ? props.scrollHeight + "px" : props.maxHeightConstraint + "px")};
`;

const ArrowContainer = styled.div`

`;

const ArrowButton = styled.button<any>`

`;

const ChevronDown = styled(IonIcon)<any>`
	font-size: 14px;
	color: #f2f2f2;
	transition: inherit;
	transition: transform 0.3s ease;
	transform: rotate(${(props) => (props.isExpanded ? "180deg" : "0deg")});
`;

const ExpandableContent = ({ children, maxHeightConstraint = 200 }: any) => {
	const [isOverflowing, setIsOverflowing] = useState(false);
	const [isExpanded, setIsExpanded] = useState(false);
	const contentRef = useRef<any>(null);

	useEffect(() => {
		const checkOverflow = () => {
			const element = contentRef.current;
			if (element) {
				const hasOverflow = element.scrollHeight > maxHeightConstraint;
				setIsOverflowing(hasOverflow);
				if (!hasOverflow) {
					setIsExpanded(false);
				}
			}
		};

		checkOverflow();
		window.addEventListener("resize", checkOverflow);
		return () => window.removeEventListener("resize", checkOverflow);
	}, [children, maxHeightConstraint]);

	return (
		<Container>
			<ContentWrapper
				ref={contentRef}
				isExpanded={isExpanded}
				scrollHeight={contentRef.current?.scrollHeight}
				maxHeightConstraint={maxHeightConstraint}>
					{children}
			</ContentWrapper>

			{isOverflowing && (
				<ArrowContainer>
					<ArrowButton
						onClick={() => setIsExpanded(!isExpanded)}
						isExpanded={isExpanded}
						aria-label={isExpanded ? "Show less" : "Show more"}>
						<ChevronDown src={chevronDown} isExpanded={isExpanded} />
					</ArrowButton>
				</ArrowContainer>
			)}
		</Container>
	);
};

export default ExpandableContent;
